import { Gavel } from '@mui/icons-material';
import { List, ListItem, styled, Typography } from '@mui/material';
import React from 'react';

const StyledLink = styled('a')({
  color: 'inherit',
  textDecoration: 'none',
  ':hover': {
    textDecoration: 'underline',
  },
});

const StyledListItem = styled(ListItem)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  paddingTop: '0',
  paddingBottom: '10px',
});

const AcceptableUse: React.FC = () => {
  return (
    <>
      <Typography
        variant="subtitle2"
        sx={{
          height: '20px',
          color: '#0047FF',
          margin: 0,
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        Responsible AI Use
      </Typography>
      <div style={{ height: 'inherit' }}>
        <List sx={{ height: 'inherit', marginTop: '10px', paddingTop: '0', paddingBottom: '0' }}>
          <StyledListItem>
            <Typography variant="body2">
              <StyledLink
                href="https://westmonroepartners1.sharepoint.com/Firm%20Wide%20Communications/Forms/AllItems.aspx?id=%2FFirm%20Wide%20Communications%2F2023%2FGen%20AI%2FAI%20Best%20Practices%2Epdf&parent=%2FFirm%20Wide%20Communications%2F2023%2FGen%20AI&p=true&ga=1"
                target="_blank"
                style={{
                  lineHeight: '20px',
                  fontSize: '14px',
                }}
              >
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <Gavel sx={{ width: '18px', mr: '3px' }} />
                  <b>Click Here to Access Guidelines</b>
                </div>
              </StyledLink>
            </Typography>

            <Typography variant="body2">
              West Monroe&apos;s Responsible AI Use Guidelines emphasize responsible and ethical use
              of AI technologies, covering key definitions, approved tools, and best practices.
              Review the link above to ensure you are familiar with confidentiality, data privacy,
              and security guidelines.
            </Typography>
          </StyledListItem>
        </List>
      </div>
    </>
  );
};

export default AcceptableUse;
